//#region packages/intl-durationformat/should-polyfill.ts
function shouldPolyfill() {
	return typeof Intl === "undefined" || !("DurationFormat" in Intl);
}
//#endregion
export { shouldPolyfill };

//# sourceMappingURL=should-polyfill.js.map